import type React from 'react';

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    to: string;
}

const Link: React.FC<LinkProps> = ({ to, children, ...rest }) => {
    return (
        <a href={to} {...rest}>
            {children}
        </a>
    );
};

export default Link;
